import React, { useEffect, useState } from "react";
import { HitApi } from "../../Api/ApiHit";
import { searchEvidence, searchTask } from "../../constant/Constant";
import PageHeader from "../../PageHeader/PageHeader";
import { CardTask } from "../../components/Cards/CardTask";
import { getElevateUser, getSelectedUnit } from "../../storage/Storage";
import TodaysTask from "./TaskTypes/TodaysTask";
import WeeklyTask from "./TaskTypes/WeeklyTask";
import MonthlyTask from "./TaskTypes/MonthlyTask";
import OneTimeTask from "./TaskTypes/OneTimeTask";
import MissedTask from "./TaskTypes/MissedTask";
import CompletedTask from "./TaskTypes/CompletedTask";
import AdminTaskDashbord from "./AdminTaskDashbord";

function MyTask() {
  // Check if user is SuperAdmin
  const userRole = getElevateUser()?.roleData?.roleType;
  const isSuperAdmin = userRole === "SuperAdmin";

  const [weekly, setWeekly] = useState(0);
  const [monthly, setMonthly] = useState(0);
  const [once, setOnce] = useState(0);
  const [todaysTask, setTodaysTask] = useState(0);
  const [missedTask, setMissedTask] = useState(0);
  const [completedTask, setCompletedTask] = useState(0);
  const [activeTab, setActiveTab] = useState("today")

  useEffect(() => {
    // Don't fetch data if SuperAdmin (they see AdminTaskDashboard)
    if (isSuperAdmin) return;

    getTasksEvidence("today");
    getTask("weekly");
    getTask("monthly");
    getTask("once");
    getTasksEvidence("missed");
    getTasksEvidence("completed"); // Added missing call
  }, [isSuperAdmin]);

  const getTasksEvidence = (type) => {
    let json = {}; // Use let instead of var

    if (type === "today") {
      const today = new Date();
      const startTime = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0).getTime();
      const endTime = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59, 59).getTime();

      json = {
        page: 1,
        limit: 1,
        search: {
          assignedTo: { $in: [getElevateUser()?._id] },
          createdAt: {
            $gte: startTime,
            $lte: endTime,
          },
        },
      };

      HitApi(json, searchEvidence)
        .then((res) => {
          console.log("call");
          if (res?.statusCode === 200) {
            const total = res?.data?.docs?.length || 0;
            setTodaysTask(total);
          }
        })
        .catch((error) => {
          console.error("Error fetching today's tasks:", error);
        });
    }

    if (type === "missed") {
      json = {
        page: 1,
        limit: 1,
        search: {
          assignedTo: { $in: [getElevateUser()?._id] },
          "taskIntervals.status": "missed",
        },
      };

      HitApi(json, searchEvidence)
        .then((res) => {
          if (res?.status === 200) { // Fixed: was checking for "today" instead of correct condition
            const total = res?.doc?.totalDocs || res?.doc?.docs?.length || 0;
            setMissedTask(total);
          }
        })
        .catch((error) => {
          console.error("Error fetching missed tasks:", error);
        });
    }

    if (type === "completed") {
      json = {
        page: 1,
        limit: 1,
        search: {
          assignedTo: { $in: [getElevateUser()?._id] },
          "taskIntervals.status": "completed"
        },
      };

      HitApi(json, searchEvidence)
        .then((res) => {
          if (res?.statusCode === 200) {
            const total = res?.data?.totalDocs || res?.data?.docs?.length || 0;
            setCompletedTask(total);
          }
        })
        .catch((error) => {
          console.error("Error fetching completed tasks:", error);
        });
    }
  };

  const getTask = (taskFrequency) => {
    const json = {
      page: 1,
      limit: 1,
      search: {
        assignedTo: { $in: [getElevateUser()?._id] },
        taskFrequency: taskFrequency,
        unitIds: getSelectedUnit()?._id,
      },
    };

    HitApi(json, searchTask)
      .then((res) => {

        console.log("res-getTask", res);
        if (res?.data?.docs) {
          const total = res?.data?.totalDocs || 0;
          if (taskFrequency === "weekly") setWeekly(total);
          if (taskFrequency === "monthly") setMonthly(total);
          if (taskFrequency === "once") setOnce(total);
        }
      })
      .catch((error) => {
        console.error(`Error fetching ${taskFrequency} tasks:`, error);
      });
  };

  const tasks = [
    { title: "Today's Tasks", count: todaysTask, description: "Tasks due today", tab: "today" },
    { title: "Weekly Tasks", count: weekly, description: "Tasks this week", tab: "weekly" },
    { title: "Monthly Tasks", count: monthly, description: "Tasks this month", tab: "monthly" },
    { title: "One Time Tasks", count: once, description: "All one-time tasks", tab: "once" },
    // { title: "Missed Tasks", count: missedTask, description: "All missed tasks", tab: "missed" },
    // { title: "Completed Tasks", count: completedTask, description: "All completed tasks", tab: "completed" },
  ];

  const handleClick = (task) => {
    console.log("task", task?.tab);
    setActiveTab(task?.tab)
  }

  // If SuperAdmin, show Admin Dashboard instead
  if (isSuperAdmin) {
    return <AdminTaskDashbord />;
  }

  return (
    <div className="md:p-5">
      <PageHeader
        title="My Task"
        description="Manage your functional tasks here"
      />
      <div className="mt-6 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-6">
        {tasks.map((task, index) => (
          <CardTask
            key={index}
            task={task}
            onClick={() => handleClick(task)}
            isActive={activeTab === task.tab}
          />
        ))}
      </div>
      <div className="mt-10">
        {activeTab === "today" && <TodaysTask />}
        {activeTab === "weekly" && <WeeklyTask />}
        {activeTab === "monthly" && <MonthlyTask />}
        {activeTab === "once" && <OneTimeTask />}
        {/* {activeTab === "missed" && <MissedTask />}
        {activeTab === "completed" && <CompletedTask />} */}
      </div>
    </div>
  );
}

export default MyTask;